/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForVcenter extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForVcenter");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForVcenter.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForVcenter>): ServiceAccountCredentialsForVcenter {
        let obj = Object.assign(new ServiceAccountCredentialsForVcenter(), model);
        ServiceAccountCredentialsForVcenter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForVcenter>): ServiceAccountCredentialsForVcenter {
        if (!model) return null;
        return ServiceAccountCredentialsForVcenter.newInstance(<ServiceAccountCredentialsForVcenter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForVcenter) {
        if (!obj) return;

        models.ServiceAccountCredentialsForVcenter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForVcenter): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForVcenter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Username. This is a required field.
     */
    username: string;

    /**
     * Password. This is a required field.
     */
    password: string;

    /**
     * Auth Host. This is a required field.
     */
    host: string;

}
